const MINIMUM_QUALITY_EDGE_SIZE = 500
const MINIMUM_MAX_ZOOM = 1.1
const MAXIMUM_MAX_ZOOM = 2
const MAX_PHOTO_AGE_DAYS = 364 // Keep photos for 1 year before deleting them from the photo bank (that's the time we should keep photos in S3)
const MAX_PHOTO_AGE = MAX_PHOTO_AGE_DAYS * 24 * 60 * 60 * 1000

export const shouldWarnLowQualityDefault = ({
  width,
  height,
}: {
  width: number
  height: number
}): boolean => {
  return Math.min(width, height) < MINIMUM_QUALITY_EDGE_SIZE
}

export function calcMaxZoom({
  width,
  height,
}: {
  width: number
  height: number
}) {
  const suggestedZoomByQuality =
    Math.min(width, height) / MINIMUM_QUALITY_EDGE_SIZE
  return Math.min(
    Math.max(suggestedZoomByQuality, MINIMUM_MAX_ZOOM),
    MAXIMUM_MAX_ZOOM
  )
}

export function isExpiredPhoto({ uploadedAt = 0, isStatic = false } = {}) {
  return (!uploadedAt || Date.now() - uploadedAt > MAX_PHOTO_AGE) && !isStatic
}
